import { render, staticRenderFns } from "./ProfileCertificatesEducationsEditor.vue?vue&type=template&id=6da7e778&scoped=true"
import script from "./ProfileCertificatesEducationsEditor.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileCertificatesEducationsEditor.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileCertificatesEducationsEditor.vue?vue&type=style&index=0&id=6da7e778&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da7e778",
  null
  
)

export default component.exports